import { APP_CONFIG, ManheimLoginQueryParams, ROUTES } from '@sd/shared';
import queryString from 'query-string';

export const getLoginUrl = (backUri = window.location.pathname + window.location.search) => {
  const loginParams: ManheimLoginQueryParams = {
    /* eslint-disable camelcase */
    ...APP_CONFIG.shared.routes.oauth.defaultLoginParams,
    redirect_uri: ROUTES.appShell.oauthCallback.externalUrlFor({}),
    state: queryString.stringify({ back_uri: backUri })
    /* eslint-enable camelcase */
  };
  return ROUTES.external.oauth.login.externalUrlFor(loginParams);
};
